import { pages } from 'src/routing/pages'
// import { defaultMapCenter } from 'data/points'

export const useChooseWarehouseLink = (): string => {
    return pages.WarehouseSearch.to()
    // return pages.WarehouseSearch.to({ location: defaultMapCenter })
}

export const useChooseWarehouseLinkMobile = (): string => {
    return pages.WarehouseSearch.to()

    // return pages.WarehouseSearch.to({
    //     location: { lat: defaultMapCenter.lat, lng: defaultMapCenter.lng - 1 }
    // })
}
